const githubChaindataBranch = "v3";
const githubChaindataBaseUrl = `https://raw.githubusercontent.com/TalismanSociety/chaindata/${githubChaindataBranch}`;
const githubChainsUrl = `${githubChaindataBaseUrl}/chaindata.json`;
const githubTestnetChainsUrl = `${githubChaindataBaseUrl}/testnets-chaindata.json`;
const githubEvmNetworksUrl = `${githubChaindataBaseUrl}/evm-networks.json`;
const githubTokensUrl = `${githubChaindataBaseUrl}/tokens.json`;
const githubChainLogoUrl = chainId => `${githubChaindataBaseUrl}/assets/chains/${chainId}.svg`;
const githubEvmNetworkLogoUrl = networkId => `${githubChaindataBaseUrl}/assets/chains/${networkId}.svg`;
const githubTokenLogoUrl = tokenId => `${githubChaindataBaseUrl}/assets/tokens/${tokenId}.svg`;
const githubUnknownTokenLogoUrl = githubTokenLogoUrl("unknown");

export { githubChainLogoUrl, githubChaindataBaseUrl, githubChaindataBranch, githubChainsUrl, githubEvmNetworkLogoUrl, githubEvmNetworksUrl, githubTestnetChainsUrl, githubTokenLogoUrl, githubTokensUrl, githubUnknownTokenLogoUrl };
